import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  FormSelectField,
  FlexRowFluid
} from "../styles/Global";
import { connect, useSelector } from "react-redux";
import { auth } from "../services/firebaseConfig";
//AG-Grid
import { AgGridReact } from "@ag-grid-community/react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { BiRefresh } from "react-icons/bi";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFilterRight } from "react-icons/bs";
//AG-Grid
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import loading from "react-useanimations/lib/loading";
import UseAnimations from "react-useanimations";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { ModuleRegistry } from "@ag-grid-community/core";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { godPowerDateOptions } from "../pages/organizer/forms/formSelectArrays";
import GodPowerSearchOptions from "./../pages/organizer/modals/components/godPower/GodPowerSearchOptions";
ModuleRegistry.registerModules([
  // ClientSideRowModelModule,
  ColumnsToolPanelModule,
  CsvExportModule,
  FiltersToolPanelModule,
  SetFilterModule,
]);

const mapDispatch = {};

const GridTableClientSecure = ({
  data,
  dataCall,
  apiURL,
  dataCallBody,
  error,
  setModalData,
  ShowModalType,
  shouldShowModal,
  columnDefs,
  rowClassRules,
  defaultColDef,
  showSearchBar,
  paginationPageSize,
  refreshGrid,
  showFilter,
  noBorder,
  noHeader,
  isFullWidthRow,
  fullWidthCellRenderer,
  overlayText,
  rowHeight,
  suppressRowClickSelection,
  suppressCellFocus,
  isGodPower,
  setDataCallBody,
  windowWidth
}) => {
  const modules = useMemo(
    () => [
      ClientSideRowModelModule,
      MenuModule,
      SetFilterModule,
      RowGroupingModule,
    ],
    []
  );
  const [openFilter, setOpenFilter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [format, setFormat] = useState("all");
  const [generation, setGeneration] = useState("all");
  const [currentDataCallBody, setCurrentDataCallBody] = useState(null);
  const gridRef = useRef();
  
  // Add state management for grid state
  const [initialState, setInitialState] = useState(
    localStorage.getItem("gridState")
      ? JSON.parse(localStorage.getItem("gridState"))
      : null)
  const [currentState, setCurrentState] = useState();

  // Load saved state from localStorage when component mounts
  useEffect(() => {
    if (isGodPower) {
      console.log('initialSTate: ', initialState);
      try {
        const savedState = localStorage.getItem('gridState');
        if (savedState) {
          setInitialState(JSON.parse(savedState));
        }
      } catch (error) {
        console.error('Error loading grid state from localStorage:', error);
      }
    }
  }, [isGodPower]);

  // Save state to localStorage when it changes
  useEffect(() => {
    if (isGodPower && currentState) {
      try {
        localStorage.setItem('gridState', JSON.stringify(currentState));
      } catch (error) {
        console.error('Error saving grid state to localStorage:', error);
      }
    }
  }, [currentState, isGodPower]);

  const onGridPreDestroyed = useCallback((params) => {
    if (isGodPower) {
      const { state } = params;
      console.log("Grid state on destroy (can be persisted)", state);
      setInitialState(state);
    }
  }, [isGodPower]);

  const onStateUpdated = useCallback((params) => {
    if (isGodPower) {
      console.log("State updated", params.state);
      setCurrentState(params.state);
    }
  }, [isGodPower]);

  const getRowData = useCallback((params) => {
    const getTokenSafely = async () => {
      try {
        if (auth.currentUser) {
          return await auth.currentUser.getIdToken(true);
        } else {
          console.error("No auth.currentUser available");
          return null;
        }
      } catch (error) {
        console.error("Error getting token:", error);
        return null;
      }
    };

    return getTokenSafely().then((accessToken) => {
      if (!accessToken) {
        console.error("Failed to get access token, retrying in 2 seconds");
        // Retry after 2 seconds if token acquisition fails
        setTimeout(() => {
          getRowData(params);
        }, 500);
        return;
      }

      fetch(
        ` https://us-central1-scoreholio.cloudfunctions.net/apisecurev2/${apiURL}`,
        // ` http://localhost:5001/scoreholio/us-central1/apisecurev2/${apiURL}`,
        {
          method: "post",
          body: JSON.stringify(params.request),
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: "Bearer " + accessToken,
          },
        }
      )
        .then((httpResponse) => httpResponse.json())
        .then((response) => {
          setTimeout(() => {
            console.log("running timeout on gridRef");
            if (gridRef.current && gridRef.current.api) {
              console.log("response.rows: ", response.rows);
              gridRef.current.api.setRowData(response.rows);
            }
          }, 1000);
        })
        .catch((error) => {
          console.error("dataSource error: ", error);
          // params.failCallback();
        });
    });
  }, []);

  const onGridReady = (params) => {
    params.request = { ...params.request, ...dataCallBody };
    console.log("params.request: ", params.request);
    getRowData(params);
  };

  useEffect(() => {
    console.log("GridTableClientSecure dataCallBody: ", dataCallBody);
    if (
      currentDataCallBody &&
      JSON.stringify(currentDataCallBody) !== JSON.stringify(dataCallBody)
    ) {
      console.log("dataCallBody useEffect running");
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.setRowData([]);
        gridRef.current.api.showLoadingOverlay();
      }
      getRowData({ request: dataCallBody });
    }
    setCurrentDataCallBody(dataCallBody);
  }, [dataCallBody]);

  const onRowClicked = useCallback((event) => {
    const selectedRow = event.data;
    //do stuff with selectedRow
    if (shouldShowModal) {
      setModalData(selectedRow);
      ShowModalType();
      event.node.setSelected(false);
    }
  }, []);

  const defaultColDefFallback = useMemo(() => {
    return {
      resizable: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
      // Add filter configuration
      filter: true,
      filterParams: {
        // Apply filter immediately as selections are made
        applyButton: false,
        resetButton: false,
        // No delay in filtering
        debounceMs: 0,
        // Don't check anything by default - opposite of standard behavior
        selectAllOnFilter: false,
        defaultToNothingSelected: true,
        // Don't show select all checkbox
        suppressSelectAll: true,
        // Use filter immediately without buttons
        buttons: [],
        closeOnApply: false,
        // Explicitly exclude the empty option
        excludeChildrenWhenTreeDataFiltering: true,
      },
    };
  }, []);

  // Update onFirstDataRendered to set up our filters
  const onFirstDataRendered = useCallback((params) => {
    if (!gridRef.current || !gridRef.current.api) return;

    // Size columns to fit
    gridRef.current.api.sizeColumnsToFit();

    // Set up filters to show all by default (nothing filtered)
    const filterModel = {};
    gridRef.current.api.setFilterModel(filterModel);

    // Initialize all filters to show everything
    gridRef.current.api.forEachNode((node) => {
      node.setSelected(false);
    });

    // Initialize filters properly
    setTimeout(() => {
      if (gridRef.current && gridRef.current.api) {
        const api = gridRef.current.api;
        api.refreshHeader();
      }
    }, 100);
  }, []);

  // Update the customFilter function to handle the reversed filtering behavior
  const customFilter = useCallback((e, type, colId) => {
    console.log("e: ", e);
    console.log("type: ", type);
    console.log("colId: ", colId);

    if (!gridRef.current || !gridRef.current.api) return;

    if (!e && type !== "search") {
      // Clear all filters
      gridRef.current.api.setFilterModel(null);
      setFormat("all");
      setGeneration("all");
    } else if (type === "search") {
      // Quick search remains the same
      gridRef.current.api.setQuickFilter(e);
      setSearchValue(e);
    } else if (type === "select") {
      const filterInstance = gridRef.current.api.getFilterInstance(colId);
      if (e === "all") {
        // Show all items for this filter
        filterInstance.setModel(null);
      } else {
        // Show only items matching this value (invert filtering)
        filterInstance.setModel({
          type: "equals",
          filter: e,
        });
      }
      // Update state for the filter type
      if (colId === "format") {
        setFormat(e);
      } else if (colId === "teamCreate") {
        setGeneration(e);
      }
      // Apply the filter immediately
      gridRef.current.api.onFilterChanged();
    }
  }, []);

  //console.log("rowData: ", data);
  const getRowHeight = useCallback(function (params) {
    // return 100px height for full width rows
    return apiURL === "organizer/stats/tournaments"
      ? 30
      : rowHeight
      ? rowHeight
      : 95;
  }, []);

  function ExportDataToolPanel() {
    const exportData = () => {
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.exportDataAsCsv();
      }
    };

    return (
      <FlexColumn
        style={{
          width: "100%",
          height: "100%",
          padding: 10,
          background: Global.backgroundColor,
        }}
        justify="center"
        align="center"
      >
        <LargeButton onClick={exportData}>
          <ButtonText>Export CSV</ButtonText>
        </LargeButton>
        <Text
          style={{
            textAlign: "center",
            fontStyle: "italic",
            maxWidth: "80%",
            marginTop: 10,
          }}
          size=".8em"
        >
          Export will only work in the web browser, not in app.
        </Text>
      </FlexColumn>
    );
  }
  const sideBar = useMemo(() => {
    const panels = [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true,
          suppressValues: true,
          suppressRowGroups: true,
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ];

    // Only add the export panel if not in GodPower mode
    if (!isGodPower) {
      panels.push({
        id: "export",
        labelDefault: "Export",
        labelKey: "export",
        iconKey: "save", // Use 'save' icon instead of 'export' which doesn't exist
        toolPanel: ExportDataToolPanel,
        toolPanelParams: {
          title: "Export",
        },
      });
    }

    return {
      toolPanels: panels,
      defaultToolPanel: "none",
    };
  }, [isGodPower]); // Add isGodPower as dependency

  //console.log("GridTableClientSecure refreshGrid: ", refreshGrid);

  return (
    <div style={{ height: "100%", width: "100%" }} className="ag-theme-alpine">
      {showSearchBar && (
        <FlexRowFluid
          justify="space-between"
          align="center"
          style={{ flex: 0, padding: "5px 10px 0 0", width: '100%' }}
          direction={isGodPower && windowWidth < 700 ? "column" : "row"}
        >
          {isGodPower && (
            <GodPowerSearchOptions
              dataCallBody={dataCallBody}
              setDataCallBody={setDataCallBody}
              windowWidth={windowWidth}
            />
          )}
          <FlexRow align='center' style={{flex: 1, width: '100%'}}>
          <div
            className="inputField"
            style={{
              marginLeft: 10,
              flex: 1,
              position: "relative",
            }}
          >
            <FormInputField
              id="outlined-basic"
              label="Search"
              variant="outlined"
              value={searchValue}
              fullWidth
              margin="dense"
              onChange={(e) => customFilter(e.target.value, "search", null)}
              style={{ padding: 0 }}
              size="small"
            />
            {searchValue !== "" && (
              <AiOutlineCloseCircle
                size={20}
                color={Global.blueLight}
                style={{
                  position: "absolute",
                  zIndex: 100,
                  right: 10,
                  top: "50%",
                  transform: `translateY(-50%)`,
                  backgroundColor: "#fff",
                  borderRadius: 20,
                }}
                onClick={() => customFilter("", "search", null)}
              />
            )}
          </div>
          <BiRefresh
            size={30}
            color={Global.blueLight}
            style={{
              padding: 2,
              marginTop: 5,
              marginLeft: 10,
              backgroundColor: "transparent",
              borderRadius: 20,
            }}
            onClick={() => getRowData({ request: dataCallBody })}
          />
          </FlexRow>
          {showFilter && (
            <BsFilterRight
              size={30}
              color={
                openFilter || format !== "all" || generation !== "all"
                  ? Global.red
                  : Global.blueLight
              }
              style={{
                padding: 2,
                marginTop: 5,
                marginLeft: 10,
                backgroundColor: "transparent",
                borderRadius: 20,
              }}
              onClick={() => setOpenFilter(!openFilter)}
            />
          )}
        </FlexRowFluid>
      )}
      <FlexColumn
        className={`filterSection ${openFilter && "showFilterSection"}`}
      >
        <FlexRow
          style={{
            marginTop: 5,
            width: "100%",
          }}
          align="center"
          justify="flex-end"
        >
          <div
            onClick={() => customFilter(null)}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Text color="red" size=".9em">
              Clear All Filters
            </Text>
            <IoMdRemoveCircleOutline
              size={20}
              color={Global.red}
              style={{
                padding: 2,
                marginLeft: 0,
                backgroundColor: "transparent",
                // borderRadius: 20,
              }}
            />
          </div>
        </FlexRow>
        <FlexRow
          style={{
            padding: "15px 0",
            width: "100%",
          }}
        >
          <FormControl fullWidth style={{ marginRight: 10 }}>
            <InputLabel id="demo-simple-select-label">Format</InputLabel>
            <Select
              labelId="game-type-select-label"
              id="game-type-select"
              value={format}
              label="Format"
              onChange={(e) => {
                console.log("event: ", e);
                setFormat(e.target.value);
                customFilter(e.target.value, "select", "format");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Round Robin">Round Robin</MenuItem>
              <MenuItem value="Single Elimination">Single Elimination</MenuItem>
              <MenuItem value="Double Elimination">Double Elimination</MenuItem>
              <MenuItem value="Pool Play">Pool Play</MenuItem>
              <MenuItem value="Set Schedule">Set Schedule</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Generation</InputLabel>
            <Select
              labelId="generation-select-label"
              id="generation-select"
              value={generation}
              label="Generation"
              onChange={(e) => {
                console.log("event: ", e);
                setGeneration(e.target.value);
                customFilter(e.target.value, "select", "teamCreate");
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Singles">Singles</MenuItem>
              <MenuItem value="Set Teams">Set Teams</MenuItem>
              <MenuItem value="Blind Draw">Blind Draw</MenuItem>
              <MenuItem value="Squadholio">Squadholio</MenuItem>
              <MenuItem value="Switcholio">Switcholio</MenuItem>
            </Select>
          </FormControl>
        </FlexRow>
      </FlexColumn>
      <AgGridReact
        gridOptions={{
          //This hides the right click context menu options on the grid
          suppressContextMenu: true,
          suppressPivotMode: true,
          suppressValues: true,
          suppressRowGroups: true,
          enableRangeSelection: true,
          enableAdvancedFilter: true,
          // Ensure these are enabled for state to work properly
          statefulSort: true,
          maintainColumnOrder: true,
        }}
        onGridReady={(params) => {
          onGridReady(params);
        }}
        className={noBorder && "noBorder"}
        // serverSideStoreType="partial"
        // rowModelType="serverSide"
        // gridOptions={gridOptions}
        pagination="true"
        paginationPageSize={paginationPageSize ? paginationPageSize : "10"}
        cacheBlockSize="50"
        suppressContextMenu="true"
        modules={modules}
        // rowHeight={rowHeight}
        ref={gridRef}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef ? defaultColDef : defaultColDefFallback}
        rowClassRules={rowClassRules}
        rowSelection="single"
        onRowClicked={onRowClicked}
        onFirstDataRendered={onFirstDataRendered}
        suppressRowClickSelection={suppressRowClickSelection}
        suppressCellFocus={suppressCellFocus}
        domLayout="autoHeight"
        headerHeight={noHeader ? 0 : 30}
        isFullWidthRow={isFullWidthRow}
        fullWidthCellRenderer={fullWidthCellRenderer}
        getRowHeight={getRowHeight}
        overlayNoRowsTemplate={`<Text style="margin-top: -45px; font-size: 1.2em">${
          overlayText ? overlayText : "No Events. Create One!"
        }</Text>`}
        overlayLoadingTemplate="<span><img height='50' src='https://app.scoreholio.com/img/loading400.gif'/></span>"
        // autoHeight={true}
        sideBar={
          apiURL === "organizer/stats/tournaments" || isGodPower
            ? sideBar
            : null
        }
        // Add state management props
        initialState={isGodPower ? initialState : undefined}
        onGridPreDestroyed={onGridPreDestroyed}
        onStateUpdated={onStateUpdated}
      />
    </div>
  );
};

export default connect(null, mapDispatch)(GridTableClientSecure);
